<template>
    <div>
        <v-card class="bg-card mb-2">
            <v-card-text>
                <v-row dense>
                    <v-col sm="12" lg="6" xl="4" class="pr-8">
                        <FormRow label="Type">            
                            <WorkorderTypeCombo dusk="workordertype" :model="model" :rules="model.rules.mandatory" v-model="model.id_workordertype"></WorkorderTypeCombo>
                        </FormRow>
                        <FormRow v-if="feature.canProject" label="Project">    
                            <ProjectPicker no-chapter-select :filter="{'selectfor':'workorder'}" :fieldMap="projectFieldMap" :model='model' :valueModel="model" v-model='model.id_project'></ProjectPicker>
                        </FormRow>
                        <FormRow label="Titel">            
                            <TextField v-model="model.title" :model="model" dusk="title" max-length="48" placeholder="Titel" :rules="model.rules.mandatory"></TextField>
                        </FormRow>
                        <FormRow label="Relatie">    
                            <RelationCombo :model='model' :rules='model.rules.mandatory' v-model='model.id_relation'></RelationCombo>
                        </FormRow>
                        <FormRow v-if="model.phone" label="">            
                            <TextField disabled v-model="model.phone" dusk="phone" placeholder="Telefoonnummer"></TextField>
                        </FormRow>
                        <FormRow label="Adres">
                            <RelationAddressCombo placeholder="Adres" :model="model" :rules="model.rules.id_address" :id_parent="model.id_relation" v-model="model.id_address"></RelationAddressCombo>
                        </FormRow>
                        <FormRow label="Contact">
                            <RelationContactCombo :model="model" :rules="model.rules.id_person" :id_parent="model.id_relation" v-model="model.id_person"></RelationContactCombo>
                        </FormRow>
                        <FormRow v-if="model.contactPhone" label="">            
                            <TextField disabled v-model="model.contactPhone" dusk="contactPhone" placeholder="Telefoonnummer"></TextField>
                        </FormRow>
                        <FormRow label="Factuur relatie">    
                            <RelationCombo sales :model='model' v-model='model.id_relation_invoice'></RelationCombo>
                        </FormRow>
                    </v-col>
                    <v-col sm="12" lg="6" xl="4">
                        <FormRow label="Referentie">            
                            <TextField v-model="model.reference" :model="model" dusk="referentie" max-length="48" placeholder="Referentie"></TextField>
                        </FormRow>
                        <FormRow label="Prioriteit">            
                            <Priority no-clearable v-model="model.priority" :model="model" :rules="model.rules.mandatory"></Priority>
                        </FormRow>

                        <FormRow label="Melddatum">            
                            <DatePicker :model="model" v-model='model.reported_at' :rules="model.rules.mandatory"></DatePicker>
                        </FormRow>

                        <FormRow label="Verwachte uitvoerdatum">            
                            <DatePicker :model="model" v-model='model.target_at' :rules="model.rules.mandatory"></DatePicker>
                        </FormRow>
                        <FormRow class="position-relative" label="In te plannen tot">            
                            <DatePicker :model="model" v-model='model.plannable_until'></DatePicker>
                            <span class="position-absolute" style="top: 8px; right: -16px;">
                            <TipMenu class="ml-2">
                                <p>Een werkbon is via het planscherm in te plannen zolang er nog geen afspraken voor ingepland zijn.</p>
                                <p>Wil je de werkbon gedurende langere tijd beschikbaar houden om in te plannen, zelfs al zijn er al eerdere afspraken voor gemaakt, voer dan deze datum in.</p> 
                                <p>In het planscherm vind je deze werkbon dan altijd terug onder 'Beschikbare werkbonnen'.</p> 
                            </TipMenu>

                            </span>
                            

                        </FormRow>
                        <FormRow label="Verwacht aantal uur">            
                            <TimeField :max24="false" dusk="estimate" v-model='model.estimate' :model='model' :rules="model.rules.mandatory"></TimeField>
                        </FormRow>
                        <FormRow label="Uitvoer notitie verplicht">            
                            <Checkbox dusk="note_mandatory" switcher :model='model' v-model='model.note_mandatory'></Checkbox>
                        </FormRow>
                        <FormRow label="Uren invullen verplicht">            
                            <Checkbox dusk="hours_mandatory" switcher :model='model' v-model='model.hours_mandatory'></Checkbox>
                        </FormRow>
                        <FormRow label="Handtekening verplicht">            
                            <Checkbox dusk="signature_mandatory" switcher :model='model' v-model='model.signature_mandatory'></Checkbox>
                        </FormRow>

                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card class="bg-card mb-2">
            <v-card-title class="text-larger py-2">
                Werkomschrijving
            </v-card-title>
            <v-card-text>
                <TextArea :model='model' placeholder='Werkomschrijving' v-model='model.description'></TextArea>                
            </v-card-text>
        </v-card>
                
   </div>
</template>



<script setup>
    

    import FormRow from '@controls/forms/FormRow'
    import TextField from '@controls/input/TextField'
    import RelationCombo from '@controls/combo/Relation'
    import ProjectPicker from '@controls/picker/Project'
    import feature from '@app/features'
    import RelationAddressCombo from '@controls/combo/RelationAddress'
    import RelationContactCombo from '@controls/combo/RelationContact'
    import WorkorderTypeCombo from '@controls/combo/WorkorderTypes'
    import Priority from '@controls/combo/Priority'
    import DatePicker from '@controls/input/DatePicker'
    import TimeField from '@controls/input/TimeField'
    import TextArea from '@controls/input/TextArea'
    import Checkbox from '@controls/check/Checkbox.vue'
    import TipMenu from "@controls/menu/TipMenu.vue";

    // Our fields which come from projects. We want them overridden when a project is selected.
    let projectFieldMap = {pro_reference: 'reference', pro_name: 'name', pro_number: 'pro_number', id_relation: "id_relation"};

    const props = defineProps({
        model: {
            type: [Object]
        },
    });

</script>
